import { analBasicInfoRequest } from 'containers/market/actions'
import { analStockRealRequest } from 'containers/market/actions'
import { makeGetAnalBasicInfo } from 'lib/selector'
import { makeGetAnalStockReal } from 'lib/selector'
import React, { memo } from 'react'
import { connect, useDispatch } from 'react-redux'
import PanelStockOverView from '../panelStockOverview'
import PanelStockSummary from '../panelStockSummary'
import PanelStockTradeHistory from '../panelStockTradeHis'
import { AlgoSignalContext } from 'containers/socket/signalAlgo'
import * as _ from 'lodash'

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`

function usePrevious(value) {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

function OverviewStock(props) {
  const as = React.useContext(AlgoSignalContext)
  const [tabActive, setTabActive] = React.useState('Tong-Hop')
  const [topShow, setTopShow] = React.useState([])
  const [indexToShow, setIndexToShow] = React.useState(null)
  const [stockRealShow, setStockRealShow] = React.useState(null)

  const dispatch = useDispatch()
  const abortController = new AbortController()

  const {
    symActive,
    analStReal,
    analBasicInfo,
    t,
    lang,
    theme,
    algoSignal,
    algoStock,
    algoSChart,
  } = props
  const preAlgoSignal = usePrevious(algoSignal)
  const preSymActive = usePrevious(symActive)
  const preAlgoStock = usePrevious(algoStock)
  const preAlgoSChart = usePrevious(algoSChart)
  const preAnalStReal = usePrevious(analStReal)

  React.useEffect(() => {
    return () => {
      abortController.abort()
      // leave
      if(symActive) {
        var msg = {
          action: 'leave',
          channelName: 'stock-realtime:' + symActive,
        }
        as.sendMessage(msg)
        msg = {
          action: 'leave',
          channelName: 'stock-chart:' + symActive,
        }
        as.sendMessage(msg)
      }
    }
  }, [])

  React.useEffect(() => {
    if (
      algoStock &&
      !_.isEqual(algoStock, preAlgoStock) &&
      algoStock?.CompanyID === analStReal?.CompanyID
    ) {
      setIndexToShow(algoStock)
    }
  }, [algoStock])

  React.useEffect(() => {
    if (
      algoSChart &&
      !_.isEqual(algoSChart, preAlgoSChart) &&
      algoSChart[0] === analStReal?.CompanyID
    ) {
      setStockRealShow(algoSChart)
      // settopshow
      setTopShow([
        {
          Time: algoSChart[1],
          PriceChange: algoSChart[3],
          MatchPrice: algoSChart[2],
          MatchVolume: algoSChart[4],
          OrderType: algoSChart[7],
          TotalBuyVolume: algoSChart[11],
          TotalSellVolume: algoSChart[12],
          BuyForeignValue: algoSChart[13],
        },
        ...topShow,
      ])
    }
  }, [algoSChart])

  React.useEffect(() => {
    if (analStReal && !_.isEqual(analStReal, preAnalStReal)) {
      setIndexToShow(analStReal)
    }
  }, [analStReal])

  React.useEffect(() => {
    console.log('algoSignal', algoSignal)
    if (algoSignal && !_.isEqual(algoSignal, preAlgoSignal) && symActive) {
      var msg = {
        action: 'reg',
        channelName: 'stock-realtime:' + symActive,
      }
      as.sendMessage(msg)
      msg = {
        action: 'reg',
        channelName: 'stock-chart:' + symActive,
      }
      as.sendMessage(msg)
    }
  }, [algoSignal])

  React.useEffect(() => {
    if (symActive && !_.isEqual(symActive, preSymActive)) {
      if (preSymActive) {
        // nếu có thay đổi mã
        var msg
        msg = {
          action: 'leave',
          channelName: 'stock-realtime:' + preSymActive,
        }
        as.sendMessage(msg)
        msg = {
          action: 'leave',
          channelName: 'stock-chart:' + preSymActive,
        }
        as.sendMessage(msg)

        // đăng ký chanel với mã mới
        msg = {
          action: 'reg',
          channelName: 'stock-realtime:' + symActive,
        }
        as.sendMessage(msg)
        msg = {
          action: 'reg',
          channelName: 'stock-chart:' + symActive,
        }
        as.sendMessage(msg)
      }
      dispatch(analStockRealRequest(symActive.toUpperCase()))
      getBasicInfo()
      getTopMatch()
    }
  }, [symActive])

  function getTopMatch() {
    if (!symActive) return
    setTopShow([])
    fetch(
      appUrl + 'pbapi/api/stockBoard/chart/stock/' + symActive.toUpperCase() + '/100',
      {
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        // // log(res);
        // processTopMatch(res.data);
        if (res.status === 200) setTopShow(res?.data?.reverse());
      })
      .catch((error) => {
        // log(error);
      })
  }

  function getBasicInfo() {
    const _params = {
      lang,
      secList: symActive.toUpperCase(),
      Exchange: '',
    }
    dispatch(analBasicInfoRequest(_params))
  }

  // log(symActive);

  console.log(stockRealShow)

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview"
      style={{ background: 'var(--bg_card_chart)', borderRadius: '2px' }}
    >
      <div className="d-flex mt-2">
        <div
          className={
            'w-50 btn-analysis first ' +
            (tabActive === 'Tong-Hop' ? 'active' : '')
          }
          onClick={() => setTabActive('Tong-Hop')}
        >
          {t('algo.bdkt.txt-overview')}
        </div>
        <div
          className={
            'w-50 btn-analysis ' + (tabActive === 'Lich-Su' ? 'active' : '')
          }
          onClick={() => setTabActive('Lich-Su')}
        >
          {t('algo.ptcp.txt-Order-book')}
        </div>
        <div
          className={
            'w-50 btn-analysis second ' +
            (tabActive === 'Dong-Tien' ? 'active' : '')
          }
          onClick={() => setTabActive('Dong-Tien')}
        >
          {t('algo.bdkt.txt-statistical')}
        </div>
      </div>
      {tabActive === 'Tong-Hop' && (
        <PanelStockOverView
          symActive={symActive}
          stockDetail={indexToShow}
          stockRealShow={stockRealShow}
          basicInfo={analBasicInfo}
          t={t}
        />
      )}
      {tabActive === 'Lich-Su' && (
        <PanelStockTradeHistory
          symActive={symActive}
          stockDetail={indexToShow}
          topShow={topShow}
          t={t}
          theme={theme}
        />
      )}
      {tabActive === 'Dong-Tien' && (
        <PanelStockSummary
          stockDetail={indexToShow}
          symActive={symActive}
          algoSChart={algoSChart}
          t={t}
        />
      )}
    </div>
  )
}

const makeMapStateToProps = () => {
  const getAnalStockReal = makeGetAnalStockReal()
  const getAnalBasicInfo = makeGetAnalBasicInfo()

  const mapStateToProps = (state) => {
    return {
      analStReal: getAnalStockReal(state),
      analBasicInfo: getAnalBasicInfo(state),
      lang: state.client?.setting?.lang || 'vi',
      algoSignal: state.socket.algoSignal,
      algoStock: state.socket.algoStock,
      algoSChart: state.socket.algoSChart,
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(memo(OverviewStock))
